import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { useTranslation } from '../i18n';
import './Legal.css';

const Terms = () => {
  const { t } = useTranslation();
  const business = process.env.REACT_APP_BUSINESS || 'SeekWebs';
  const email = process.env.REACT_APP_EMAIL || 'contato@seekwebs.com.br';
  const businessName = process.env.REACT_APP_BUSINESS_NAME || 'CRF DIGITAL MARKETING LTDA';
  const cnpj = process.env.REACT_APP_CNPJ || '44.230.574/0001-21';
  const street = process.env.REACT_APP_STREET || 'RUA SEBASTIAO DA ROCHA PITA, 120';
  const neighborhood = process.env.REACT_APP_NEIGHBORHOOD || 'JARDIM SANTA GENEBRA';
  const city = process.env.REACT_APP_CITY || 'SAO PAULO';
  const state = process.env.REACT_APP_STATE || 'SP';
  const zipcode = process.env.REACT_APP_ZIPCODE || '13.080-300';

  return (
    <>
      <Helmet>
        <title>{t('terms.title')} - {business}</title>
        <meta name="description" content={`${t('terms.title')} - ${business}`} />
      </Helmet>

      <div className="legal-container">
        <motion.header
          className="legal-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link to="/" className="back-link">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12 16L6 10L12 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {t('common.backToHome')}
          </Link>
        </motion.header>

        <motion.main
          className="legal-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h1>{t('terms.title')}</h1>
          <p className="last-update">{t('terms.lastUpdate')}</p>

          <section>
            <h2>{t('terms.sections.identification.title')}</h2>
            <p>{t('terms.sections.identification.intro')}</p>
            <div className="company-details">
              <p><strong>{businessName}</strong></p>
              <p>CNPJ: {cnpj}</p>
              <p>{street}, {neighborhood}</p>
              <p>{city} - {state} - CEP: {zipcode}</p>
              <p>Email: {email}</p>
            </div>
          </section>

          <section>
            <h2>{t('terms.sections.acceptance.title')}</h2>
            <p>{t('terms.sections.acceptance.content', { business })}</p>
          </section>

          <section>
            <h2>{t('terms.sections.serviceUse.title')}</h2>
            <p>{t('terms.sections.serviceUse.content', { business })}</p>
          </section>

          <section>
            <h2>{t('terms.sections.privacy.title')}</h2>
            <p>{t('terms.sections.privacy.content')} <Link to="/politicas">{t('terms.sections.privacy.link')}</Link></p>
          </section>

          <section>
            <h2>{t('terms.sections.content.title')}</h2>
            <p>{t('terms.sections.content.content')}</p>
          </section>

          <section>
            <h2>{t('terms.sections.limitations.title')}</h2>
            <p>{t('terms.sections.limitations.content')}</p>
          </section>

          <section>
            <h2>{t('terms.sections.modifications.title')}</h2>
            <p>{t('terms.sections.modifications.content')}</p>
          </section>

          <section>
            <h2>{t('terms.sections.applicableLaw.title')}</h2>
            <p>{t('terms.sections.applicableLaw.content', { city, state })}</p>
          </section>

          <section>
            <h2>{t('terms.sections.contact.title')}</h2>
            <p>{t('terms.sections.contact.content', { email })}</p>
          </section>
        </motion.main>
      </div>
    </>
  );
};

export default Terms;
